import React from "react";
import { useParams } from "react-router-dom";

/**
 * Thin host for the self-contained Side B quiz.
 * The actual page is served as a static file at /side-b.html and runs
 * untouched inside this iframe (inline Web Audio, its own CSS, no React).
 * A slug, when present, is passed through as a query param; the static
 * page reads it and adjusts its own behaviour.
 */
export default function TapeFrame() {
  const { slug } = useParams();
  const src = slug ? `/side-b.html?slug=${encodeURIComponent(slug)}` : "/side-b.html";
  return (
    <iframe
      title="Side B"
      src={src}
      allow="autoplay"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
        background: "#0E1E1B",
      }}
    />
  );
}
